import { Component, Input } from '@angular/core';

@Component({
	selector: 'ac-actions-drawer',
	templateUrl: './actions-drawer.component.html',
	styleUrls: ['./actions-drawer.component.scss']
})
export class ActionsDrawerComponent {
	@Input() public showActions: boolean;
	@Input() public showAtTop: boolean = false;
}
